
document.addEventListener("DOMContentLoaded", () => {
  console.log("🟣 BUY BOX — SINGLE VARIANT MODE + DRAWER FIX");

  /* ======================================================
     VARIANTE ÚNICA DEL PRODUCTO
  ====================================================== */
  const VARIANT_ID = 41451840307333; // único variant del producto

  console.log("🧩 VARIANTE CONFIG:", {
    variant: VARIANT_ID
  });

  /* ======================================================
     LEER CANTIDAD DESDE SHADOW HOST
  ====================================================== */
  function getSingleQtyFromShadow() {
    try {
      const qty = window.getSingleQty(); 
      console.log("🔎 Cantidad desde ShadowRoot:", qty);
      return qty;
    } catch (e) {
      console.error("❌ No se pudo leer getSingleQty()", e);
      return 1;
    }
  }

  /* ======================================================
     ABRIR SOLO EL CART DRAWER (NO EL OVERLAY DEL MENÚ)
  ====================================================== */
  function openInstantDrawer() {
    console.log("🟣 OPEN DRAWER — método seguro");
    document.dispatchEvent(new CustomEvent("instant:cart:open"));
  }

  /* ======================================================
     REFRESH INSTANT
  ====================================================== */
  async function forceInstantRefresh() {
    console.log("🔄 FORCING INSTANT REFRESH…");

    const cart = await fetch("/cart.js").then(r => r.json());
    console.log("🟣 CART DE SHOPIFY →", cart);

    if (window?.Instant?.api?.updateCart) {
      console.log("🟣 USANDO Instant.api.updateCart(cart)");
      window.Instant.api.updateCart(cart);
    } else {
      console.log("🟣 USANDO fallback instant:cart:sync");
      document.dispatchEvent(
        new CustomEvent("instant:cart:sync", { detail: { cart } })
      );
    }

    setTimeout(() => {
      console.log("🟣 Drawer Items Luego de REFRESH:");
      document.querySelectorAll("[data-instant-repeater-type='CART_ITEMS']")
        .forEach((el, index) => {
          const title = el.querySelector("[data-instant-dynamic-content-source='TITLE']")?.textContent?.trim();
          const price = el.querySelector("[data-instant-dynamic-content-source='PRICE']")?.textContent?.trim();
          const qty = el.querySelector("[data-instant-dynamic-content-source='QUANTITY_SELECT']")?.value;
          console.log(`   📌 ITEM ${index+1}:`, { title, price, qty });
        });
    }, 400);
  }

  /* ======================================================
     BOTÓN CUSTOM ATC
  ====================================================== */
  const atc = document.querySelector(".btn-add-to-cart");

  console.log("🟣 INIT — ATC BUTTON →", {
    found: !!atc,
    node: atc
  });

  if (!atc) return;

  atc.addEventListener("click", async (e) => {
    e.preventDefault();
    e.stopImmediatePropagation();

    console.log("🟣 [CLICK] Add To Cart PRESSED");

    /* ============================
       A — OBTENER CANTIDAD
    ============================ */
    const qty = getSingleQtyFromShadow();

    if (qty <= 0) {
      alert("Elegí una cantidad válida");
      return;
    }

    console.log("🟣 Cantidad final seleccionada:", qty);

    /* ============================
       B — UPDATE SHOPIFY CART
    ============================ */
    const updates = {
      [VARIANT_ID]: qty
    };

    console.log("📡 Enviando /cart/update.js →", updates);

    let cartObj;

    try {
      const updateResponse = await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates })
      });

      console.log("📡 Status:", updateResponse.status);

      await updateResponse.json();

      const cartRes = await fetch("/cart.js");
      cartObj = await cartRes.json();

      console.log("🧾 /cart.js RESULTADO REAL:", cartObj);

      console.table(cartObj.items.map(i => ({
        TITLE: i.title,
        VARIANT: i.variant_id,
        QTY: i.quantity
      })));
    } catch (err) {
      console.error("❌ Error durante update:", err);
      return;
    }

    /* ============================
       C — REFRESH + OPEN DRAWER
    ============================ */
    console.log("🟣 REFRESH + DRAWER…");

    await forceInstantRefresh();

    // 🔥 ESTA LÍNEA ES LA CORRECTA → SOLO abre el CART DRAWER
    openInstantDrawer();

    console.log("✨ FIN — ADD TO CART COMPLETO");
  });
});
